import React from "react";
import Link from "next/link";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Grid } from "@mui/material";
import styles from "./styles/unisearch_community.module.scss";
import { getAssets } from "@unisearch/helpers";

export const UnisearchCommunity = () => {
  const settings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
  };

  const Community = () => (
    <div className={`${styles.title_wrapper}`}>
      <h2 className={`${styles.title} fw400`}>
        Hear From Our <br />
        <span className="mark"> UniSearch Community</span>
      </h2>
      <p className={`${styles.sub_title} sub_title`}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec tellus leo
        elementum sed suspendisse sagittis, nascetur nulla proin. Habitasse
        ultricies nec felis, ut tempus, sed. Quis duis praesent in dolor. Nulla
        integer.
      </p>
      <div className={styles.author_wrapper}>
        <div className={styles.name}>Marinda Botha</div>
        <div className={styles.designation}>Student</div>
      </div>
    </div>
  );

  return (
    <section className={styles.section_community}>
      <div className="container">
        <Grid
          container
          spacing={2}
          alignItems={"center"}
          className={styles.community}
        >
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/home/community.png")}
                alt="Unisearch Community"
              />
            </div>
          </Grid>

          <Grid item sm={12} md={6} className={styles.community_slider}>
            <div className="community_slider">
              <Slider {...settings}>
                <Community />
                <Community />
                <Community />
              </Slider>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UnisearchCommunity;
